var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ComponentPropsProvider, useComponentPropsFor } from '../context/component-props-context';
import { EntityCarousel } from './entity-carousel';
var cls = classNames('slice-carousel');
export var SliceCarouselDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var CarouselStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceCarousel',
  Carousel: styled(EntityCarousel)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), CarouselStyles)
};
export var SliceCarousel = function (props) {
  var _a = useComponentPropsFor(My.NAME, props, SliceCarouselDefaultProps),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    transitionType = _a.transitionType;
  var _b = entity.links,
    links = _b === void 0 ? [] : _b,
    _c = entity.backgroundImages,
    backgroundImages = _c === void 0 ? [] : _c,
    color = entity.color;
  var itemsToUse = !!links.length ? links : backgroundImages;
  return React.createElement(ComponentPropsProvider, {
    value: {
      EntityBanner: {
        showOverlay: true,
        variant: 'image',
        customAspectRatio: {
          base: 4 / 3,
          landscape: 21 / 9,
          tablet: 21 / 9
        }
      }
    }
  }, React.createElement(My.Carousel, {
    className: cls.name(className),
    items: itemsToUse,
    transitionType: transitionType,
    slideControls: {
      variant: 'line',
      showNavigationButtons: true,
      colors: {
        fill: color === null || color === void 0 ? void 0 : color.value,
        active: {
          background: color === null || color === void 0 ? void 0 : color.value
        }
      },
      arrowColors: {
        fill: color === null || color === void 0 ? void 0 : color.value,
        hover: {
          fill: color === null || color === void 0 ? void 0 : color.value
        }
      }
    }
  }));
};
SliceCarousel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;